export default __webpack_public_path__ + "static/media/user-delete.df6360c1.svg";